module.exports = __webpack_public_path__ + "img/pdf.4b935201.svg";